import http from "../http-common";

class MiscService {
  getContacts = () => http.get("/contacts");

  getContact = (contact_id) => http.get(`/contacts/${contact_id}`);

  getUser = (user_id) => http.get(`/users/${user_id}`);

  getUsers = () => http.get("/users");

  getProcess = ()=> http.get("/processtypes")

  addProcess = (type_name)=> http.post("/addprocess",{type_name})

  getOutstandingClaims = () => http.get("/outstanding-claims");

  searchOutstandingClaims = (q) => http.get("/outstanding-claims/search", { params: { q } });

  getRecalls = () => http.get("/recalls");

  getAppointments = (contact_id) => http.get(`/contacts/${contact_id}/appointments`);

  getCalls = () => http.get("/calls");

  getCallRecordingURL = (call_uuid) => http.defaults.baseURL + `/calls/${call_uuid}/recording`;

  // getTexts = () => http.get("/texts");

  // getEmails = () => http.get("/emails");

  updateActiveStatus = (user_id) => http.put(`/admin/update-active-status/${user_id}`);

  updatePassword = (data) => http.put("/settings/password", data);

  sendAccountActivationEmail = (email, data) => http.post(`activate-account/${email}`, data);

  updateDarkMode = (dark_mode) => http.post("/user/dark_mode", { dark_mode });

  setContactType =(contact_id,type_id) => http.put(`/contact/${contact_id}/contact_type/${type_id}`);


  getConversationsForContact = (contact_id, offset, limit, direction) => http.get(`/conversations/contact/${contact_id}/offset/${offset}/limit/${limit}?direction=${direction}`);

  getAllUserConversations = (user_id, offset, limit, direction) => http.get(`/conversations/users/${user_id}/offset/${offset}/limit/${limit}?direction=${direction}`);

  getFamilyMembersConversations = (memberIds, offset, limit, direction) => http.post(`/conversations/family/offset/${offset}/limit/${limit}?direction=${direction}`, memberIds);

  getMultimediaUrl = (textMsgId, mediaId) => http.defaults.baseURL + `/messages/text_message/${textMsgId}/media/${mediaId}`;
  getMultimedia = (msgId,mediaId) => http.get(`/messages/${msgId}/media/${mediaId}`);
  getEmailMediaUrl = (email_id,media_id) => http.defaults.baseURL + `/messages/email/${email_id}/media/${media_id}`; // 
  getmediaURL =(mediaId,contact_id)=>http.defaults.baseURL + `/contact/${contact_id}/media/${mediaId}`;
  getMessageMediaForContact = (contact_id) => http.get(`/messages/message_media/contact/${contact_id}`);

  getContactTypes = () => http.get(`/contact_types`);

  getEmailsForThread = (thread_id) => http.get(`/threadEmails/${thread_id}`);

  getLatestEmailMessage = (comm_participant_id) => http.get(`/latestEmail/${comm_participant_id}`);

  getMediasForEmail = (email_id) => http.get(`/emails/media/${email_id}`);

  createContactType = (data)=>http.post('/contact_types',data);

  updateContactType = (data,type_id)=>http.put(`/contact_types/${type_id}`,data);

  // Message Templates 
  
  getMessageTemplates = () => http.get("/message-templates");

  createMessageTemplate = (data) => http.post("/message-templates", data);

  updateMessageTemplate = (template_id, data) => http.put(`/message-templates/${template_id}`, data);

  deleteMessageTemplate = (template_id) => http.delete(`/message-templates/${template_id}`);

  getSyncStatus= () => http.get("/mail/sync/status");

  getWidgetEmbedSnippet = (src) => http.get("/settings/widget-embed", { params: { src } });


  //conversation tag filter
  getConversationTagContacts =(tag_id, offset)=> http.get(`/conversation_tag/filtertag_id/${tag_id}/offset/${offset}`);

  //add conversation message notes
  addConversationNotes =(conversation_id,data) => http.post(`/conversation_notes/conversation_id/${conversation_id}`,data);

}

export default new MiscService();
